import { TFunction } from 'i18next';
import React from 'react';
import { ProjectStatus } from '../../atoms/ProjectStatus/ProjectStatus';
import { TableColData } from '../../atoms/Table/Table';
import { WindowDisplayState } from '../../modules/Windows/WBSElement/WBSElement.helpers';
import { Components } from '../../utils/types';
import { WBSNameCell } from './WBSNameCell';

type Props = {
    selectedWBSStructure: Components.Schemas.WBSStructureDTO | undefined;
    filteredData: Components.Schemas.WBSElementDeltaDTO[];
    openNodes: Components.Schemas.WBSElementDeltaDTO[];
    toggleOpenNode: (node?: Components.Schemas.WBSElementDeltaDTO | undefined) => void;
    detailWindowMode: WindowDisplayState;
    t: TFunction;
};

export const getBubbleTableData = ({
    selectedWBSStructure,
    filteredData,
    openNodes,
    toggleOpenNode,
    detailWindowMode,
    t,
}: Props): TableColData[] => [
    {
        name: t('table.cols.wbsName'),
        cellRender: (i) => (
            <WBSNameCell
                baseData={selectedWBSStructure}
                displayData={filteredData}
                i={i}
                openNodes={openNodes}
                toggleOpenNode={toggleOpenNode}
            />
        ),
        className: 'TableRowName ProTable__levels',
        colSpace: 'extend',
    },
    // {
    //     name: t('table.cols.action'),
    //     cellRender: (i) => (
    //         <>
    //             <ActionCell
    //                 i={i}
    //                 elmentId={filteredData[i]?.id}
    //                 detailWindowMode={detailWindowMode}
    //                 hightlightOnHover
    //             />
    //         </>
    //     ),
    //     className: `ProTable__buttons`,
    //     colSpace: 3,
    // },
    {
        name: t('table.cols.status'),
        cellRender: (i) => <ProjectStatus delta={filteredData[i]} id={filteredData[i]?.id} />,
        className: 'ProTable__status',
        colSpace: 3,
    },
];
